import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export const EnquireDialog = ({ property }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/enquiries", { property_id: property.id, message });
      toast.success("Enquiry sent. We'll be in touch personally.");
      setOpen(false);
      setMessage("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid={`property-enquire-btn-${property.id}`}
          className="w-full h-11 border border-[#121417] text-sm font-medium hover:bg-[#121417] hover:text-white transition-colors duration-300">
          Enquire with us
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#FBFBF9] rounded-none sm:max-w-lg" data-testid="enquire-dialog">
        <DialogHeader>
          <p className="eyebrow">Private enquiry</p>
          <DialogTitle className="font-display text-2xl font-medium">{property.title}</DialogTitle>
          <DialogDescription>Your details go to us only. The seller never sees your contact information.</DialogDescription>
        </DialogHeader>
        {user ? (
          <form onSubmit={submit} className="space-y-4">
            <textarea data-testid="enquire-message-input" value={message} onChange={(e) => setMessage(e.target.value)} rows={4}
              placeholder="Anything we should know? e.g. preferred viewing times"
              className="field-input h-auto py-3" />
            <button type="submit" disabled={loading} data-testid="enquire-submit-btn"
              className="w-full h-12 bg-[#9F7E44] text-white text-sm hover:bg-[#866835] disabled:opacity-60 transition-colors">
              {loading ? "Sending…" : "Send enquiry"}
            </button>
            <p className="text-xs text-[#847F77]">Tip: register as a verified buyer to be prioritised for viewings.</p>
          </form>
        ) : (
          <div className="space-y-3">
            <p className="text-sm text-[#57534E]">Create a free account or sign in to send an enquiry.</p>
            <Link to="/auth?mode=register&next=/properties" data-testid="enquire-register-link"
              className="flex items-center justify-center h-12 bg-[#9F7E44] text-white text-sm hover:bg-[#866835]">Create account</Link>
            <Link to="/auth?next=/properties" data-testid="enquire-signin-link"
              className="flex items-center justify-center h-12 border border-[#121417] text-sm">Sign in</Link>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
